import Auth from "./Auth/Reducer";
import General from "./General/Reducer";
import Analytics from "./Analytics/Reducer";

export default {
    Auth,
    General,
    Analytics
}